import { ITasksInProgress, IAccountingOverviewChartData, IDepartmentOverviewChart, IDepartmentOverviewChartData } from './../../../types/dashboard'
import { IProject, IProjectsDashboardStats } from '../../project/types/project'
import * as constants from '../actions/constants'
import { GlobalDashboardActions } from '../actions/dashboardActions'


export const tasksInProgress = (state: ITasksInProgress[] = [], action: GlobalDashboardActions): ITasksInProgress[] => {
  switch (action.type) {
    case constants.GET_TASKS_IN_PROGRESS_SUCCESS:
      return action.tasks

    default:
      return state
  }
}

export const accountingOverview = (state: IAccountingOverviewChartData = {categories: [], data: []}, action: GlobalDashboardActions): IAccountingOverviewChartData => {
  switch (action.type) {
    case constants.GET_ACCOUNTING_OVERVIEW_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const accountingOverviewPeriod = (state = 'year', action: GlobalDashboardActions): string => {
  switch (action.type) {
    case constants.SET_ACCOUNTING_OVERVIEW_PERIOD:
      return action.period

    default:
      return state
  }
}

export const departmentOverview = (state: IDepartmentOverviewChart = {expenditures: {} as IDepartmentOverviewChartData, tracked_hours: {} as IDepartmentOverviewChartData}, action: GlobalDashboardActions): IDepartmentOverviewChart => {
  switch (action.type) {
    case constants.GET_DEPARTMENT_OVERVIEW_SUCCESS:
      return action.data

    default:
      return state
  }
}

const initialProjectsDashboardStats: IProjectsDashboardStats = {
  active_count: 0,
  new_active_count: 0,
  deleted_count: 0,
  inactive_count: 0
}

export const projectsDashboardStats = (
  state: IProjectsDashboardStats = initialProjectsDashboardStats,
  action: GlobalDashboardActions
): IProjectsDashboardStats => {
  switch (action.type) {
    case constants.GET_PROJECTS_DASHBOARD_STATS_SUCCESS:
      return action.stats

    default:
      return state
  }
}

export const projectsInDanger = (
  state: IProject[] = [],
  action: GlobalDashboardActions
): IProject[] => {
  switch (action.type) {
    case constants.GET_PROJECTS_IN_DANGER_SUCCESS:
      return action.projects

    default:
      return state
  }
}
